<template>
  <div class="page page-buses">
    <img class="page-banner" src="../../assets/banners/bikes.jpeg">
    <div class="page-header">
        <div>
            <h2><WFTranslate k="page-bikes">Download the HSL app</WFTranslate></h2>
            <img class="page-image" src="../../assets/pages/hsl.png">
        </div>
    </div>
    <div class="page-description flex">
        <WFTranslate k="page-bikes-description"></WFTranslate>
        <button class="btn btn-border btn-lg" @click="showRoute('group', 'bikes')">
            <WFIcon name="path"></WFIcon>
            <WFTranslate k="show_path">Show route</WFTranslate>
        </button>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    watch: {
        page () {
            console.log('page', this.page)
        }
    },
    data () {
        return {
            routes1: {
                "routes": [20, 22, 23, 24, 25, 26, 28, 29, 30],
                "reds": [20, 22, 25, 30 ]
            },
            routes2: {
                "routes": [ 1, 2, 3, 4, 5, 7, 8, 10, 11, 12, 17],
                "reds": [7]
            }
        }
    },
    computed: {
        croutes1 () {
            return this.routes1.routes.map((r) => {
                return {
                    name: r,
                    class: this.routes1.reds.indexOf(r) > -1 ? "red" : "blue"
                }
            });
        },
        croutes2 () {
            return this.routes2.routes.map((r) => {
                return {
                    name: r,
                    class: this.routes2.reds.indexOf(r) > -1 ? "red" : "blue"
                }
            });
        }
    },
    mounted () {
        console.log('page2', this.page)
    },
    methods: {
        showRoute (type, slug) {
            this.$emit('showRoute', type, slug)
        },
        viewOnMap (type, slug) {
            this.$emit("viewOnMap", type, slug);
        }
    }
}
</script>

<style lang="less">
    .page-buses {
        .page-header {
            display: flex;
            flex-direction: column;

            & > div {
                display: flex;
                justify-content: space-between;
                
            }

            label {
                margin-top: 2.4rem;
            }
        }

        .btn {
            margin-left: 2rem;
        }

        .page-description img {
            height: 3.8rem;
            width: auto;
        }

        .routes div {
            width: 3.8rem;
            height: 3.8rem;
            background-color: #1E88E5;
            margin-right: 0.5rem;
            border-radius: 50%;
            color: white;
            font-size: 1.6rem;
            font-weight: 600;
            line-height: 3.9rem;
            text-align: center;

            &.red {
                background-color: #EE1D23;
            }
        }
    }
</style>